module.exports = __webpack_public_path__ + "img/cloudview-poster-image.fe1c09a8.jpg";